import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { removePopover, pushPopover } from './actionCreators';
import { getPopover } from './selectors';
export var usePopover = function (id) {
    var dispatch = useDispatch();
    var popover = useSelector(function (state) {
        return getPopover(state, id);
    });
    return {
        popover: popover,
        removePopover: useCallback(function () { return dispatch(removePopover(id)); }, [
            id,
            dispatch,
        ]),
        pushPopover: useCallback(function (options) { return dispatch(pushPopover(id, options)); }, [
            id,
            dispatch,
        ]),
        togglePopover: useCallback(function () {
            if (popover.isOpen) {
                dispatch(removePopover(id));
            }
            else {
                dispatch(pushPopover(id));
            }
        }, [id, dispatch, popover.isOpen]),
    };
};
//# sourceMappingURL=hooks.js.map